import * as React from 'react';
import {FlatList, Pressable, StyleSheet, TextInput, TouchableOpacity} from 'react-native';
import { View, Text, Image } from 'react-native';
import {DrawerActions, useNavigation} from "@react-navigation/native";
import {Avatar} from "react-native-paper";
import {windowWidth} from "../utils/Dimentions";
import { Ionicons, Entypo, MaterialCommunityIcons } from '@expo/vector-icons';
import CardItem from "../components/CardItem";


const data1 = [
    {
        Country: 'Nigeria',
        name: 'Kayode Joseph',
    }, {
        Country: 'France',
        name: 'Dolan Anderson ',
    },{
        Country: 'Italy',
        name: 'Melisa Porter',
    },{
        Country: 'Germany',
        name: 'Jodi Bocarnan',
    },
]

const data2 = [
    {
        Country: 'India',
        name: 'Julius Putman',
    },{
        Country: 'South Africa',
        name: 'Kathline Carter',
    }, {
        Country: 'USA',
        name: 'James Lanham',
    },{
        Country: 'Canada',
        name: 'Ronald McAlister',
    },
]


export default function Dashboard() {
    const navigation = useNavigation();
    const userImage = require("../assets/john.png")


    return (
        <View style={styles.container}>
            <View style={styles.header}>
                <View style={styles.headerLeft}>
                    <TouchableOpacity>
                        <Ionicons name="search" size={18} color="gray" />
                    </TouchableOpacity>
                    <View>
                        <TextInput style={styles.searchBox} placeholder={"search"}></TextInput>
                    </View>
                </View>
                <View style={styles.headerRight}>
                    <View style={styles.right}>
                        <Ionicons name="notifications" size={18} color="#52525A" />
                        <View style={styles.lang}>
                            <Text style={styles.text0}>EN</Text>
                            <Entypo name="chevron-down" size={18} color="#52525A" />
                        </View>
                    </View>
                    <View style={styles.left}>
                        <View>
                            <Text style={styles.text1}>John Doe</Text>
                            <Text style={styles.text2}>Oxford University</Text>
                        </View>
                        <TouchableOpacity style={styles.avatar} onPress={() => ({})}>
                            <Avatar.Image
                                source={{uri: userImage}}
                                size={40}
                            />
                        </TouchableOpacity>
                    </View>
                </View>
            </View>

            <View style={styles.mainContainer}>
                <View style={styles.leftContainer}>
                    <View style={styles.upContainer}>
                        <View style={styles.profile}>
                            <Text style={styles.text3}>Hi, John Doe</Text>
                            <Text style={styles.text4}>
                                Welcome back, please use the Start Verification button shown
                                below to verify your desired students Academic credentials.
                                You can now verify students credentials using either their
                                (Government Issued ID: 'NIN', 'National ID', 'Voters Card') or
                                (Ruach Public Key: Student's Verified Profile link)
                            </Text>
                            <TouchableOpacity style={styles.button} onPress={() => navigation.navigate('Verify')}>
                                <Text style={styles.textButton}>START VERIFICATION</Text>
                            </TouchableOpacity>
                        </View>
                        <View style={styles.imageContainer}>
                            <Image
                                style={styles.image}
                                source={require('../assets/Avatar.png')}/>
                        </View>
                    </View>
                    <View style={styles.bottomContainer}>
                        <View style={styles.history}>
                            <Text style={styles.text3}>History</Text>
                            <TouchableOpacity>
                                <Text style={styles.text6}>View all</Text>
                            </TouchableOpacity>
                        </View>
                        <View style={styles.historyContainer}>

                            <FlatList
                                data={data1}
                                keyExtractor={({name}) => name }
                                horizontal
                                showsHorizontalScrollIndicator={false}
                                renderItem={({item}) => <CardItem Country={item.Country} Name={item.name}/>}
                            />

                        </View>
                        <View style={styles.historyContainer}>

                            <FlatList
                                data={data2}
                                keyExtractor={({name}) => name }
                                horizontal
                                showsHorizontalScrollIndicator={false}
                                renderItem={({item}) => <CardItem Country={item.Country} Name={item.name}/>}
                            />

                        </View>

                    </View>
                </View>
                <View style={styles.rightContainer}>
                    <View style={styles.boxContainer}>
                        <View style={styles.logoContainer}>
                            <Ionicons name="people" size={18} color="#2C69C8" />
                            <View style={styles.textContainer}>
                                <Text style={styles.text7}>Students Verified</Text>
                                <Text style={styles.text1}>3,972</Text>
                            </View>
                        </View>
                    </View>
                    <View style={styles.boxContainer}>
                        <View style={styles.logoContainer}>
                            <Ionicons name="earth" size={18} color="#2C69C8" />
                            <View style={styles.textContainer}>
                                <Text style={styles.text7}>Countries</Text>
                                <Text style={styles.text1}>154</Text>
                            </View>
                        </View>
                    </View>
                    <View style={styles.boxContainer}>
                        <View style={styles.logoContainer}>
                            <Ionicons name="document" size={18} color="#2C69C8" />
                            <View style={styles.textContainer}>
                                <Text style={styles.text7}>Credentials Saved to Database</Text>
                                <Text style={styles.text1}>1,595</Text>
                            </View>
                        </View>
                    </View>
                    <View style={styles.boxContainer}>
                        <View style={styles.logoContainer}>
                            <MaterialCommunityIcons name="google-analytics" size={18} color="#2C69C8" />
                            <View style={styles.textContainer}>
                                <Text style={styles.text7}>Average Weekly Verification</Text>
                                <Text style={styles.text1}>372</Text>
                            </View>
                        </View>
                    </View>
                    <View style={styles.textAnalytics}>
                        <Text style={styles.text1}>Analytics</Text>
                    </View>
                    <View style={styles.graphContainer}>
                        <Image
                            style={styles.graph}
                            source={require('../assets/Chart.png')}/>
                    </View>
                </View>
            </View>

        </View>
    );
}

const styles = StyleSheet.create({
    container: {
        flex: 1,
        alignItems: 'center',
        backgroundColor: 'white',
    },
    mainContainer: {
        flexDirection: 'row',
        alignItems: 'center',
        width: '95%',
        flex: 1,
        marginBottom: 10,
    },
    leftContainer: {
        height: '100%',
        alignItems: 'center',
        //backgroundColor: 'green',
        justifyContent: 'space-between',
        width: '60%',
    },
    upContainer: {
        height: '30%',
        alignItems: 'center',
        backgroundColor: 'whitesmoke',
        width: '100%',
        borderRadius: 20,
        flexDirection: 'row',
    },
    bottomContainer: {
        height: '67%',
        alignItems: 'center',
        justifyContent: 'space-around',
        width: '100%',
    },
    rightContainer: {
        height: '100%',
        alignItems: 'center',
        backgroundColor: 'whitesmoke',
        width: '35%',
        marginLeft: 50,
        borderRadius: 20,
    },
    header: {
        width: '95%',
        height: 60,
        alignItems: 'center',
        justifyContent: 'space-between',
        flexDirection: 'row',
        top: 10,
        marginBottom: 20,
    },
    headerLeft: {
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'center',
        width: '30%',
        height: 40,
        borderRadius: 20,
        backgroundColor: 'whitesmoke',
    },
    headerRight: {
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'space-around',
        width: '25%',
        height: 40,
        borderRadius: 20,
    },
    searchBox: {
        marginLeft: 20,
        borderWidth: 0,
        height: 25,
        width: 250,
        marginRight: 20,
    },
    lang: {
        flexDirection: 'row',
        marginLeft: 20,
        justifyContent: 'center',
        alignItems: 'center',
    },
    left: {
        flexDirection: 'row',
        alignItems: 'center',
    },
    right: {
        flexDirection: 'row',
        alignItems: 'center',
    },
    text0: {
        fontSize: 14,
        fontWeight: '500',
        color: 'black',
        marginRight: 10,
    },
    text1: {
        fontSize: 14,
        fontWeight: '500',
        color: 'black',
    },
    text2: {
        fontSize: 12,
        color: 'gray',
    },
    textButton: {
        fontSize: 10,
        color: 'whitesmoke',
        fontWeight: '500',
    },
    text3: {
        fontSize: 14,
        fontWeight: '500',
        color: 'black',
        marginBottom: 10,
    },
    text6: {
        fontSize: 12,
        fontWeight: '500',
        color: 'grey',
    },
    text7: {
        fontSize: 12,
        color: 'black',
    },
    text4: {
        fontSize: 12,
        color: 'black',
        fontWeight: '400',
        lineHeight: 20,
    },
    text5: {
        fontSize: 14,
        color: 'white',
    },
    avatar: {
        marginLeft: 10,
        marginRight: 10,
    },
    profile: {
        width: '60%',
        alignItems: 'flex-start',
        justifyContent: 'center',
        marginLeft: 40,
    },
    button: {
        backgroundColor: 'black',
        height: 30,
        width: 150,
        borderRadius: 7,
        alignItems: 'center',
        justifyContent: 'center',
        marginTop: 10,
    },
    imageContainer: {
        width: '30%',
        marginLeft: 20,
        marginTop: 10,
        marginBottom: 10,
        height: '90%',
    },
    image: {
        resizeMode: "contain",
        height: '100%',
        width: '100%',
    },
    history: {
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center',
        width: '90%',
    },
    historyContainer: {
        height: '43%',
        alignItems: 'center',
        justifyContent: 'center',
        width: '100%',
        borderRadius: 20,
        flexDirection: 'row',
        marginTop: 10,
    },
    boxContainer: {
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center',
        width: '75%',
        height: '9%',
        backgroundColor: '#ffffff',
        borderRadius: 10,
        marginTop: 20,
        shadowOffset: { width: 0, height: 1 },
        shadowOpacity: 0.8,
        shadowRadius: 2,
        shadowColor: 'gray',
        elevation: 2,
    },
    logoContainer: {
        flexDirection: 'row',
        justifyContent: 'center',
        alignItems: 'center',
        marginLeft: 20,
    },
    textContainer: {
        marginLeft: 20,
        alignItems: 'flex-start',
        justifyContent: 'center',
        textAlign: 'left',
    },
    textAnalytics: {
        alignItems: 'flex-start',
        justifyContent: 'center',
        textAlign: 'left',
        width: '75%',
        marginTop: 30,
    },
    graphContainer: {
        alignItems: 'center',
        width: '75%',
        height: '35%',
        borderRadius: 10,
        marginTop: 20,
    },
    graph: {
        resizeMode: 'contain',
        height: '100%',
        width: '100%',
    },
});
